import { Brand, Contact, Feature, Hero, Navbar, Partners } from "./components"

function App() {
  return (
    <>
      <Navbar />
      <Hero />
      <Brand />
      <Partners />
      <Feature />
      <Contact />
    </>
  );
}

export default App;
